import { render, staticRenderFns } from "./DateRepresentation.vue?vue&type=template&id=10c80f8c&scoped=true&"
import script from "./DateRepresentation.vue?vue&type=script&lang=js&"
export * from "./DateRepresentation.vue?vue&type=script&lang=js&"
import style0 from "./DateRepresentation.vue?vue&type=style&index=0&id=10c80f8c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c80f8c",
  null
  
)

export default component.exports